export default __webpack_public_path__ + "static/media/Brew Burger - proportioned_170.37c12803.jpg";